import BaseError from "./baseError";

export default class ApiAuthTokenError extends BaseError {
  constructor() {
    super("API auth token not found");
  }
} 